import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { areYou, yourHome } from 'src/lib/flow/text';

function isEnabled() {
  return true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `When ${areYou(answers, channel)} likely to sell ${yourHome(answers, channel)}?`;
}

const saleTimelinePage: FlowPage = {
  slug: () => 'sale-timeline',
  isEnabled,
  autoAdvance: () => true,
  title,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.sale_timeline',
      type: 'exclusives_radio_single_select',
      options: [
        {
          label: 'Within the next month',
          value: 'ASAP',
        },
        {
          label: 'In the next 1-3 months',
          value: '1 - 3 months',
        },
        {
          label: 'In the next 3-6 months',
          value: '3 - 6 months',
        },
        {
          label: 'In the next 6-12 months',
          value: '6 - 12 months',
        },
        {
          label: "I'm just browsing",
          value: 'Just Browsing',
        },
      ],
    },
  ],
};

export default saleTimelinePage;
